import { useTranslation } from "react-i18next";

import { NOTIFICATION_ACTION_PRESENTATION } from "./utils";
import type { NotificationAction } from "../constants";

import { Button } from "@/components/ui/v2/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/v2/tooltip";

type NotificationActionButtonProps = {
  action: NotificationAction;
  onClick: () => void;
  className?: string;
};

export function NotificationActionButton({ action, onClick, className }: NotificationActionButtonProps) {
  const { t } = useTranslation();
  const { labelKey, icon: Icon } = NOTIFICATION_ACTION_PRESENTATION[action];
  const label = t(labelKey);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button type="button" variant="ghost" size="icon-sm" aria-label={label} onClick={onClick} className={className}>
          <Icon aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
